import React, { memo, useMemo, useState, useEffect } from "react";
import { useSearch } from "../../contexts/SearchContext";
import { useNavigate } from "react-router-dom";
import { errorMessage } from "../../services/swalService";
import { RiTimerLine } from "react-icons/ri";
import "./Timer.scss";
import { useTimer } from "../../contexts/TimerContext";

// Convert seconds to "MM:SS" format
const secondsToTime = (totalSeconds) => {
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

// Memoized time display to prevent unnecessary renders
const TimeDisplay = memo(({ seconds }) => {
  const formattedTime = useMemo(() => secondsToTime(seconds), [seconds]);
  return (
    <div className="tw-font-bold tw-text-orange-500 time">{formattedTime}</div>
  );
});

TimeDisplay.displayName = "TimeDisplay";

// Memoized timer icon component
const TimerIcon = memo(() => (
  <RiTimerLine className="tw-flex-shrink-0 tw-text-orange-500 tw-transform-gpu" />
));
TimerIcon.displayName = "TimerIcon";

function Timer() {
  const { reRunSearch } = useSearch();
  const navigate = useNavigate();
  const { getTimeLeft, stopTimer } = useTimer();
  const [displayTime, setDisplayTime] = useState(getTimeLeft()); // Local state for UI updates

  // Update display every second without causing re-renders
  useEffect(() => {
    const interval = setInterval(() => {
      setDisplayTime(getTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, [getTimeLeft]);

  // Handle timeout when timer reaches zero
  useEffect(() => {
    if (getTimeLeft() === 0) {
      stopTimer();
      errorMessage("הזמן המוקצב לחיפוש אזל, הינך מועבר לעמוד חיפוש").finally(
        () => {
          reRunSearch();
          navigate("/p/dashboard/searchoffer");
        }
      );
    }
  }, [getTimeLeft, stopTimer, reRunSearch, navigate]);

  // Render nothing when time is up
  if (getTimeLeft() === 0) {
    return null;
  }

  return (
    <div className="tw-h-10 tw-relative tw-overflow-visible tw-my-4 tw-mb-5  tw-transform tw-will-change-transform tw-will-change-opacity md:tw-mx-3 tw-w-full  ">
      <div className="tw-flex tw-items-center tw-justify-center tw-bg-white tw-rounded-lg tw-mt-1 tw-py-2 tw-px-4 tw-text-sm tw-text-gray-800 md:tw-max-w-fit tw-shadow tw-self-start tw-transform-gpu tw-backface-hidden tw-transition-all tw-animate-[timerFade_0.3s_cubic-bezier(0.2,0,0.2,1)] tw-gap-1">
        <TimerIcon />
        לחיפוש זה נותרו
        <TimeDisplay seconds={displayTime} />
        דקות
      </div>
    </div>
  );
}

export default memo(Timer);
